import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import { translate } from 'store/modules/base/i18n';
import React from 'react';
import PropTypes from 'prop-types';
import withBoundary from 'component/ErrorBoundary/withBoundary';

const useStyles = makeStyles(() => {
  return {
    indicator: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
});

/**
 * React {@code Component} for showing an icon with a tooltip.
 *
 * @returns {ReactElement}
 */
const BaseIndicator = ({
  className = '',
  icon: Icon,
  iconClassName,
  iconColor,
  iconId,
  iconSize,
  id = '',
  t,
  tooltipKey,
  tooltipPosition = 'top'
}) => {
  const classes = useStyles();
  const style = {};

  if (iconSize) {
    style.width = iconSize;
  }

  return (
    <div className={classes.indicator}>
      <Tooltip content={t(tooltipKey)} position={tooltipPosition}>
        <span className={className} id={id} style={{ display: 'contents' }}>
          <Icon
            className={iconClassName}
            color={iconColor}
            width={10}
            height={10}
            id={iconId}
            style={style}
          />
        </span>
      </Tooltip>
    </div>
  );
};

export default React.memo(translate(withBoundary(BaseIndicator)));
/**
 * The type of the React {@code Component} props of {@link BaseIndicator}.
 */
BaseIndicator.propTypes = {
  /**
   * Additional CSS class name.
   */
  className: PropTypes.string,

  /**
   * The icon component to use.
   */
  icon: PropTypes.any,
  t: PropTypes.func,

  /**
   * The CSS classnames to set on the icon element of the component.
   */
  iconClassName: PropTypes.string,

  /**
   * The color of the icon.
   */
  iconColor: PropTypes.string,

  /**
   * Id of the icon to be rendered.
   */
  iconId: PropTypes.string,

  /**
   * The font size for the icon.
   */
  iconSize: PropTypes.number,

  /**
   * The ID attribute to set on the root element of the component.
   */
  id: PropTypes.string,

  /**
   * The translation key to use for displaying a tooltip when hovering over
   * the component.
   */
  tooltipKey: PropTypes.string,

  /**
   * From which side of the indicator the tooltip should appear from,
   * defaulting to "top".
   */
  tooltipPosition: PropTypes.string
};
